// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/ApprovalRequest.yaml
// Generated: 2026-02-28T16:35:55.253Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateApprovalRequest, UpdateApprovalRequest, ApprovalRequest } from '@/types/workflow/ApprovalRequest';

/**
 * ApprovalRequest Service
 * CRUD operations for ApprovalRequest via the ABP API.
 */
export const approvalRequestService = new EntityService<ApprovalRequest, CreateApprovalRequest, UpdateApprovalRequest>(
  '/api/workflow/approvalrequest',
  'ApprovalRequest',
);
